import { render, staticRenderFns } from "./postChannel.vue?vue&type=template&id=53625b57&scoped=true"
import script from "./postChannel.vue?vue&type=script&lang=js"
export * from "./postChannel.vue?vue&type=script&lang=js"
import style0 from "./postChannel.vue?vue&type=style&index=0&id=53625b57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53625b57",
  null
  
)

export default component.exports